import { SparkLibraryStatus } from '@/app/common/general-types/spark-ads-v3.dto';

/** The three screens, mapped to the `:subTab` route segment. */
export type SparkAdsView = 'dashboard' | 'new' | 'videos';

export const SPARK_ADS_VIEWS: readonly SparkAdsView[] = ['dashboard', 'new', 'videos'] as const;

export function isSparkAdsView(value: string | null | undefined): value is SparkAdsView {
  return value === 'dashboard' || value === 'new' || value === 'videos';
}

/** Date-range presets on the dashboard header. */
export type SparkRangePreset = '7d' | '14d' | '30d';

export const SPARK_RANGE_PRESETS: readonly { key: SparkRangePreset; label: string; days: number }[] =
  [
    { key: '7d', label: '7d', days: 7 },
    { key: '14d', label: '14d', days: 14 },
    { key: '30d', label: '30d', days: 30 },
  ] as const;

/** Library filter pills. `all` is the default. */
export type SparkLibraryFilter = 'all' | SparkLibraryStatus;

export const SPARK_LIBRARY_FILTERS: readonly { key: SparkLibraryFilter; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'cleared', label: 'Cleared' },
  { key: 'awaitingAuth', label: 'Awaiting auth' },
  { key: 'sparked', label: 'Sparked' },
] as const;

/** Sort options on the builder's post grid. */
export type SparkPostSort = 'topPerforming' | 'newest';

/** The four wizard steps. Step 4 is review and launch. */
export type SparkBuilderStep = 1 | 2 | 3 | 4;

/** Shared shape for the loading/error state machine used across these screens. */
export type SparkLoadState = 'idle' | 'loading' | 'loaded' | 'error';
